<template>
<div>
    <div id="passCheck" :class="bgClass" v-if="status!==''">
        <div id="headers">
            <i class="arr" @click="goBack()"></i>
            <p class="title">{{title}}</p>
        </div>
        <v-touch @swipeleft="swiperLeft" class="wrapper">
            <p class="dsh" v-if="ptype == '0'">待审核</p>
            <p class="dsh" v-if="ptype == '-3'&&backDay!=''">已返京{{backDay}}天</p>
            <p class="dsh" v-if="ptype == '-2'">通行证已失效</p>
            <!-- 显示小区名 -->
            <div class="areaBox" v-if="ptype==1 || ptype==-3">
                <p class="areaName" v-if="pass == 1 || pass == 2">{{communityInfo.community}}</p>
                <p class="time" v-if="pass == 1">{{owner!='访客'?'欢迎回家':''}} {{uptime | formatDate}}</p>
                <p class="time" v-else-if="pass == 2">{{owner!='访客'?'一路平安':''}} {{uptime | formatDate}}</p>
            </div>
            <p class="name" v-if="ptype!='-2'">{{(owner=='访客')?'临时':''}}通行证</p>
             <!-- v-if="!isDone" -->
            <div class="code" v-if="ptype!='-2'">
                <img :src="imgSrc" alt="">
                <canvas id="QRCode"></canvas>
                <p>{{name}}</p>
            </div>
            <p v-if="(owner=='访客'&&expire_time!='')" style="margin-bottom:10px;">有效期至{{expire_time}}</p>
            <p v-if="ptype == '-2'" @click="reAdd">点击重新申请通行证 ></p>
            <p v-else>请向管理员出示本通行证</p>
            <p v-if="isManager=='1'" class="gocenter" @click="goCenter">去管理中心 ></p>
            <div class="btm">
                <a href="javascript:;" @click="goHome">去微社区</a>
                <a href="javascript:;" class="pmsg" @click="intoPerson">个人信息</a>
                <p class="company" @click="intoSup">技术支持：优腾科技</p>
            </div>
           
        </v-touch>
    </div>
    <div v-else style="display:none;">加载中...</div>
</div>
</template>
<script>
import Top from "@/component/top/top";
import axios from 'axios'
import QRCode from "qrcode";
import { Toast,Indicator  } from 'mint-ui';
import moment from 'moment'
export default {
    components:{
        Top
    },
    data() {
        return {
            backDay:'',
            pass:'',
            owner:null,
            imgSrc:'',
            timer:null,
            name:'',
            title:'通行证',
            status:'',
            uptime:'',
            communityInfo:'',
            code:'',
            openId:'',
            isUseshow:false,
            isManager:'',
            bgClass:'',
            isDone:false,
            ptype:'',
            expire_time:''
        }
    },
    filters:{
        formatDate(time) {
            return moment().format('YYYY-MM-DD HH:mm:ss')
        }
    },
    created() {
        // 判断是否登录
        // this.setuserToken("wr7w4pRzr4pK8a5ZC090rM8K7Jm95Acz")
        // this.getInfo()
        // 判断最新小区二维码逻辑
        document.title = '通行证'
        if(this.$route.query.state=='1') {
            localStorage.setItem('submitPass','1')
            localStorage.setItem('pass','1')
        }else if(this.$route.query.state=='2') {
            localStorage.setItem('pass','2')
            localStorage.setItem('submitPass','2')
        }
        axios.post(this.commonIp()+'/v1/mobile/community/userInfo')
        .then((res) => {
            if(res.data.code=='200') {
                this.setuserToken(res.data.data.token)
                this.getInfo()
            }else if(res.data.code == '424'||res.data.code == '423'){
                if (this.isAndroid() || this.isIos()) {
                    window.location.href = "app://login";
                } else {
                    // lng=116.467125&lat=39.996747
                    window.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
                }
            }
        })
    },
    beforeDestroy() {
        clearInterval(this.timer); 
        this.timer = null;
    },
    methods:{
        intoSup() {
            this.$router.push({path:'/support'})
        },
        intoPerson() {
            this.$router.push({path:`/xxdetail?&poiId=${this.$route.query.poiId}&type=user&openId=${this.openId}`})
        },
        goBack() {
            this.$router.push({path:'/',query:{state:0,poiId:this.$route.query.poiId}})
        },
        goHome() {
            this.$router.push({path:`/?poiId=${this.$route.query.poiId}&state=0`})
            localStorage.setItem("pass",'')
        },
        goCenter() {
            this.$router.push({path:`/mcenter`,query:{poiId:this.$route.query.poiId}})
        },
        getInfo() {
            // let pass = this.$route.query.pass?this.$route.query.pass:''
            let pass = localStorage.getItem('pass')
            this.pass = pass
            axios.get(this.commonIp()+`/v1/userCard/my?pass=${pass}&token=${this.getuserToken()}&poiId=${this.$route.query.poiId}`)
            .then((res) => {
                if(res.data.code == '200') {
                    // 修改cLogin值
                    if(res.data.data.userCard==null) {
                        this.$router.push({path:`/addmsg?poiId=${this.$route.query.poiId}`})
                    }else{
                        // 清空pass值
                        localStorage.setItem('pass','')
                        // this.status = 0
                        this.status = res.data.data.userCard.status
                        this.ptype = res.data.data.userCard.type
                        this.name = res.data.data.userCard.name
                        this.bgClass =  this.ptype
                        this.code = res.data.data.userCard.code
                        this.openId = res.data.data.userCard.openId
                        this.isManager = res.data.data.isManager
                        this.owner = res.data.data.userCard.owner
                        this.expire_time = res.data.data.userCard.expire_time
                        if(res.data.data.userCard.expire_time != '') {
                            let expireTimeDate = moment(res.data.data.userCard.expire_time, 'YYYY-MM-DD').toDate();
                            this.isDone = expireTimeDate.getTime() < moment().startOf('day').toDate().getTime()
                        }else{
                            this.isDone = false
                        }
                        if(res.data.data.userCard.return_date != '') {
                            let returnTimeDate = moment(res.data.data.userCard.return_date, 'YYYY-MM-DD').toDate();
                            let returnDay = moment().startOf('day').toDate().getTime() - returnTimeDate.getTime()
                            if(returnDay>=0) {
                                let day = parseInt(returnDay/1000/60/60/24) + 1 
                                if(day<=14) {
                                    this.backDay = day 
                                }
                            }
                        }
                        if(this.ptype=='-2'||this.ptype=='-3') {
                            this.bgClass = 'sxBg'
                        }else if(this.ptype == '1') {
                            if(this.owner=='访客') {
                                this.bgClass = 'fkBg'
                            }else{
                                this.bgClass = 'dshBg'
                            }
                        }
                        
                        if(this.ptype=='-1') {
                            this.$router.push({path:`/xxdetail?type=user&poiId=${this.$route.query.poiId}`})
                        }
                        // this.pass = res.data.data.pass
                        // if(res.data.data.pass=='1' || res.data.data.pass=='2' ){
                        //     this.isUseshow = true
                        // }
                        if (this.pass == '1' || this.pass == '2'){
                            this.isUseshow = true
                        }
                        if(res.data.data.userCard.community!=null) {
                            this.communityInfo = res.data.data.userCard.community
                        }

                        // 检测是否有效
                        let _this = this
                        this.timer = setInterval(function() {
                            axios.post(_this.commonIp()+'/v1/userCard/checkCodeInfo',{
                                token:_this.getuserToken(),
                                poiId:_this.$route.query.poiId,
                                code:_this.code
                            }).then((res) => {
                                if(res.data.code == '200') {
                                    if(res.data.data.codeInfo.isUse=='1') {
                                        clearInterval(_this.timer)
                                        _this.pass = 1
                                        _this.isUseshow = true
                                        _this.ptype = res.data.data.userCard.type
                                        _this.name = res.data.data.userCard.name
                                        _this.bgClass =  _this.ptype
                                        _this.owner = res.data.data.userCard.owner
                                        _this.expire_time = res.data.data.userCard.expire_time
                                        // console.log(res.data.data.userCard)
                                        if(_this.ptype=='-2'||_this.ptype=='-3') {
                                            _this.bgClass = 'sxBg'
                                        }else if(_this.ptype == '1') {
                                            if(_this.owner=='访客') {
                                                _this.bgClass = 'fkBg'
                                            }else{
                                                _this.bgClass = 'dshBg'
                                            }
                                        }
                                        
                                    }else if(res.data.data.codeInfo.isUse=='-1') {
                                        Toast('通行证信息不规范，请重新填写')
                                        // _this.$router.push({path:`/addmsg?poiId=${_this.$route.query.poiId}`})
                                        _this.$router.push({path:`/xxdetail?poiId=${_this.$route.query.poiId}&openId=${_this.openId}&type=user`})
                                    }
                                }else{
                                    clearInterval(_this.timer)
                                    Toast(res.data.message)
                                }
                            })
                        },2000)
                        this.QRCodeMsg(this.commonIp()+`/htmls/community/#/xxdetail?state=1&poiId=${this.$route.query.poiId}&code=${this.code}&openId=${this.openId}`)
                        
                    }
                }else{
                    Toast(res.data.message)
                    location.reload() 
                }
            })
        },
        QRCodeMsg(val) {
            // 获取页面的canvas
            var canvas = document.getElementById("QRCode");
            var _this = this
            QRCode.toDataURL(val, function (err, url) {
                if (err) {
                    console.log(err);
                    return
                }
                _this.imgSrc = url;
            })
        },
        swiperLeft() {
            // alert('22')
            
        },
        reAdd() {
            this.$router.push({path:`/xxdetail?poiId=${this.$route.query.poiId}&openId=${this.openId}&type=user`})   
        }
    }
}
</script>
<style lang="less">
    @import "~@/assets/less/index.less";
    @keyframes nameAnimate{
        from {color:#000;}
        to {color:yellow;}
    }

    #passCheck{
        position: fixed;
        top:0;
        width:100%;
        height: 100%;
        background:#fea025;
        padding:80px 0 80px;
        text-align: center;
        #QRCode{
            display:none;
        }
        .gocenter{
            margin-top:10px;
        }
        .name{
            font-size:36px;
            animation:nameAnimate 1s infinite;
            -moz-animation:nameAnimate 1s infinite; /* Firefox */
            -webkit-animation:nameAnimate 1s infinite; /* Safari and Chrome */
            -o-animation:nameAnimate 1s infinite; /* Opera */
        }
        &.dshBg{
            background:#92d050;
        }
        &.fkBg{
            background: #3287da;
        }
        &.sxBg{
            background:red;
        }
        .dsh{
            margin-bottom:20px;
            font-size:24px;
        }
        .areaBox{
            margin-bottom:20px;
            .areaName{
                font-size:@ft18;
                font-weight: 800;
                margin-bottom:10px;
                .time{
                    font-size:@ft14;
                }
            }
        }
        .code{
            margin:15px 0 50px;
            img{
                width:120px;
                height: 120px;
            }
        }
        .btm{
            position: fixed;
            bottom:20px;
            width:100%;
            text-align: center;
            .company{
                color:#0145BD;
                margin-top:15px;
                font-size:@ft14;
                font-weight: 700;
            }
            a{
                color:#323232;
                font-size:@ft14;
                padding:0 22px;
                display: inline-block;
                background:url('~@/assets/imgs/g.png') no-repeat left center;
                background-size:15px;
                &.pmsg{
                    position: relative;
                    padding-right:0;
                    background-image:url('~@/assets/imgs/p.png');
                    &::before{
                        content:'';
                        display: inline-block;
                        width:1px;
                        position: absolute;
                        height:18px;
                        background:#323232;
                        left:-14px;
                        top:2px;
                    }
                }
            }
        }
    }
    @media screen and (max-width:360px){
        #passCheck{
            padding-top:60px;
        }
        #QRCode{
            width: 200px;
            height: 200px;
        }
        #passCheck .code{
            margin-bottom:32px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/passcheck/passcheck.vue